export const reactSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled ? "#f5f5f5" : "#fff",
    borderColor: "#e4e4e4",
    borderRadius: "10px",
    minHeight: "50px",
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
    "&:hover": {
      borderColor: "#0077b6",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Ensure dropdown is above other elements
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f8f9fa" : "#fff",
    color: state.isFocused ? "#303030" : "#303030",
    "&:active": {
      color: "#fff",
      backgroundColor: "#0077b6",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#8b8c89" : "#303030",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#6c757d",
  }),
};

export const landingPageReactSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled ? "#f5f5f5" : "#345E8F",
    borderColor: "#e4e4e4",
    borderRadius: "10px",
    minHeight: "45px",
    width: "100%",
    border: "none",

    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : "null",
    "&:hover": {
      borderColor: "#0077b6",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Ensure dropdown is above other elements
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f8f9fa" : "#fff",
    color: state.isFocused ? "#303030" : "#303030",
    "&:active": {
      color: "#fff",
      backgroundColor: "#0077b6",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#8b8c89" : "#fff",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#fff",
    letterSpacing: "-1px",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#fff" : "#fff", // or whatever color you want
    ":hover": {
      color: "#efefef", // color on hover
    },
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#fff" : "#fff", // or whatever color you want
    ":hover": {
      color: "#efefef", // color on hover
    },
  }),

  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff", // chip background
    borderRadius: 4,
    padding: "2px 4px",
  }),

  multiValueLabel: (provided, state) => ({
    ...provided,
    fontWeight: "500",
  }),
};
